const { sendTrackingEvent } = require('../service/tidalTracking.service');
const utils = require('../utils/tracking.util');

/** @type {import('@tidal/tracking').TidalTrackingInterface} */
let instance;

/** @type {import('@tidal/tracking').TidalTrackingInterface} */
class TidalTracking {
    /**
     * @param {string} eventName
     * @param {import('@tidal/tracking').EventDataParams} eventData
     * @param {import('@tidal/tracking').OptionalParams} [options]
     * */
    sendTidalPageViewEvent(eventName, eventData, options = {}) {
        const paramsData = Object.assign({}, eventData, options);
        return sendTrackingEvent(
            this.useProductionEndpoint,
            eventName,
            {
                client: utils.getClientData(paramsData),
                payload: Object.assign(
                    utils.getBasePayloadData(paramsData),
                    {
                        previousRoute: '',
                        currentRoute: window.location.pathname,
                        trackingurl_params: Object.assign(
                            { awc: eventData.awc },
                            eventData.utms,
                        ),
                        loginuser: options.loginUser,
                    },
                ),
            },
        );
    }

    /**
     * @param {string} eventName
     * @param {import('@tidal/tracking').EventDataParams} eventData
     * @param {import('@tidal/tracking').OptionalParams} [options]
     * */
    sendTidalClickEvent(eventName, eventData, options = {}) {
        const paramsData = Object.assign({}, eventData, options);
        return sendTrackingEvent(
            this.useProductionEndpoint,
            eventName,
            {
                client: utils.getClientData(paramsData),
                payload: Object.assign(
                    utils.getBasePayloadData(paramsData),
                    { buttonId: options.buttonId },
                ),
            },
        );
    }

    /**
     * @param {string} eventName
     * @param {import('@tidal/tracking').EventDataParams} eventData
     * @param {import('@tidal/tracking').OptionalParams} [options]
     * */
    sendTidalSignupCompletionEvent(eventName, eventData, options = {}) {
        const paramsData = Object.assign({}, eventData, options);
        return sendTrackingEvent(
            this.useProductionEndpoint,
            eventName,
            {
                client: utils.getClientData(paramsData),
                payload: Object.assign(
                    utils.getBasePayloadData(paramsData),
                    {
                        trackingurl_params: Object.assign(
                            { awc: eventData.awc },
                            eventData.utms,
                        ),
                        campaignPeriod: eventData.trialLength,
                    },
                ),
            },
        );
    }

    /**
     * @param {string} eventName
     * @param {import('@tidal/tracking').LinkEventPayload} payload
     *
     * */
    sendTidalTrackingLinkEvent(eventName, payload) {
        return sendTrackingEvent(
            this.useProductionEndpoint,
            eventName,
            {
                client: {},
                payload,
            },
        );
    }

    /** @param {import('@tidal/tracking').TidalTrackingOptions} config */
    constructor(config) {
        this.useProductionEndpoint = config ?
            (config.useProductionEndpoint || false) : false;
    }
}

/**
 * @param {import('@tidal/tracking').TidalTrackingOptions} options
 * @returns {import('@tidal/tracking').TidalTrackingInterface}
 */
module.exports = (options) => instance ?
    instance : instance = new TidalTracking(options);
